import create from 'zustand';

interface FilterStore {
  currentFilters: string[];
  filterState: any; // The complete filterState object from FindAudio.jsx
  setCurrentFilters: (filters: string[]) => void;
  setFilterState: (filterState: any) => void;
  setFilters: (filters: string[], filterState: any) => void; // Convenience method to set both at once
}

export const useFilterStore = create<FilterStore>((set) => ({
  currentFilters: [],
  filterState: null,
  setCurrentFilters: (filters) => set({ currentFilters: filters }),
  setFilterState: (filterState) => set({ filterState }),
  setFilters: (filters, filterState) => set({ currentFilters: filters, filterState }),
})); 